import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { appCatalogUrl } from "../urls";
export const fetchAppTrustData = (mpacBaseUrl, appKey, state) => fetchOk(appCatalogUrl(mpacBaseUrl, "/rest/2/addons/".concat(appKey, "/privacy-and-security?state=").concat(state))).then(resp => resp.json());
export const publishAppTrustData = (mpacBaseUrl, appKey) => {
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return fetchOk(appCatalogUrl(mpacBaseUrl, "/rest/2/addons/".concat(appKey, "/privacy-and-security/publish")), options);
};
export const saveAppTrustData = (mpacBaseUrl, appKey, data) => {
  const options = {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return fetchOk(appCatalogUrl(mpacBaseUrl, "/rest/2/addons/".concat(appKey, "/privacy-and-security")), options);
};
export const deleteFormData = (mpacBaseUrl, appKey) => {
  const URL = mpacBaseUrl + "/rest/2/addons/".concat(appKey, "/privacy-and-security");
  return fetchOk(URL, {
    method: 'DELETE'
  });
};